export const buildAccountTeamAndAdminsSectionProps = ({
    WrapperComponent,
    cmsComponents,
    fetchClientTeamMemberSelectLabel,
    fetchAccountTeamMemberSelectLabel,
    fetchAccountAdminSelectLabel,
    setOpenClientTeamDialog,
    setOpenAccountTeamDialog,
    setOpenAccountAdminDialog,
    clientTeamTableData,
    setClientTeamTableData,
    accountTeamMemberTableData,
    setAccountTeamMemberTableData,
    accountAdminTableData,
    setAccountAdminTableData,
    rhfFormInstance,
    wasAdminEdited,
    setWasAdminEdited,
}) => {
    return {
        WrapperComponent,
        cmsComponents,
        fetchClientTeamMemberSelectLabel,
        fetchAccountTeamMemberSelectLabel,
        fetchAccountAdminSelectLabel,
        onOpenClientTeamDialog: () => {
            setOpenClientTeamDialog(true);
        },
        onOpenAccountTeamDialog: () => {
            setOpenAccountTeamDialog(true);
        },
        onOpenAccountAdminDialog: () => {
            setOpenAccountAdminDialog(true);
        },
        clientTeamTableData: clientTeamTableData || [],
        setClientTeamTableData,
        accountTeamMemberTableData: accountTeamMemberTableData || [],
        setAccountTeamMemberTableData,
        accountAdminTableData: accountAdminTableData || [],
        setAccountAdminTableData,
        rhfFormInstance,
        wasAdminEdited,
        setWasAdminEdited,
    };
};
